module.exports = __webpack_public_path__ + "static/media/oppo.052c599e.png";